{
  "help": "Hjælp",
  "info": "Oplysninger"
}
